import { render, staticRenderFns } from "./Connect2CoursePanel.vue?vue&type=template&id=12a66d6a"
import script from "./Connect2CoursePanel.vue?vue&type=script&lang=js"
export * from "./Connect2CoursePanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports